import { jsPDF as JsPdfConstructor } from 'jspdf';
import { applyPlugin } from 'jspdf-autotable/es';

applyPlugin(JsPdfConstructor);

export const jsPDF: any = JsPdfConstructor;
